import { SelectInputV2, SelectInputV2Props } from '@frontend/basic-forms';
import { IoTTriggerName } from '@frontend/iot/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useIoTTriggerSelect from './iot-trigger-select.controller';

const ID = 'iot-trigger-select';
export interface IoTTriggerSelectProps extends Omit<SelectInputV2Props<IoTTriggerName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const IoTTriggerSelect = (props: IoTTriggerSelectProps) => {
    const viewProps = useIoTTriggerSelect(props);

    return (
        <SelectInputV2<IoTTriggerName>
            {...props}
            id={ID + props.id}
            label={props.label || 'IoT trigger'}
            options={viewProps.options}
        />
    );
};
